var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCirclePlay = function SvgCirclePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.405 21.201 6.227-4.666c.36-.267.36-.8 0-1.067l-6.227-4.667a.666.666 0 0 0-1.066.534v9.333c0 .547.626.867 1.066.533Zm1.6-18.533c-7.36 0-13.333 5.973-13.333 13.333s5.973 13.334 13.333 13.334S29.34 23.36 29.34 16c0-7.36-5.974-13.333-13.334-13.333Zm0 24c-5.88 0-10.666-4.787-10.666-10.667S10.125 5.335 16.005 5.335c5.88 0 10.667 4.786 10.667 10.666 0 5.88-4.787 10.667-10.667 10.667Z",
    fill: "#fff"
  })));
};
export default SvgCirclePlay;